module.exports = __webpack_public_path__ + "img/placeholder.3629a0ea.png";